import {
  EventEmitter,
  Input,
  Output,
  Component,
} from "@angular/core";
import { CommonModule } from "@angular/common";
import { PrimeNGSharedModule } from "../../prime/prime-ng.module";
// Import constants
import { CUSTOMER_ONBOARDING_CONSTANTS } from "@core/constants/constants";

@Component({
  selector: "app-modal",
  imports: [CommonModule,PrimeNGSharedModule],
  templateUrl: "./modal.component.html",
  styleUrl: "./modal.component.scss",
})
export class ModalComponent {
  // Constants
  readonly CUSTOMER_ONBOARDING_CONSTANTS = CUSTOMER_ONBOARDING_CONSTANTS;

  @Input() visible: boolean = true;
  @Input() header: string = CUSTOMER_ONBOARDING_CONSTANTS.ADD_CUSTOMER_MODAL_TITLE;
  @Input() cancelButtonText: string = CUSTOMER_ONBOARDING_CONSTANTS.CANCEL_BUTTON_LABEL;
  @Input() submitButtonText: string = CUSTOMER_ONBOARDING_CONSTANTS.SUBMIT_BUTTON_LABEL;
  @Output() visibleChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() onCancel: EventEmitter<void> = new EventEmitter<void>();
  @Output() onSubmit: EventEmitter<void> = new EventEmitter<void>();
  @Input() isInfoDialog: boolean = false;
  @Input() isInfoDialogButtonText: string = "Done";
  @Input() showFooterBorder: boolean = true;

  close() {
    this.visible = false;
    this.visibleChange.emit(this.visible);
  }
}